<template>
  <!-- Debug Grid -->
  <div v-if="false" class="display-grid container grid grid-cols-12 gap-9 fixed left-1/2 -translate-x-1/2 top-0 h-screen z-[999] pointer-events-none">
    <div v-for="i in 12" :key="`grid-col-${i}`" class="col-span-1 h-full bg-red/15"></div>
  </div>
</template>
